/*!
 * Color mode toggler for Bootstrap's docs (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under the Creative Commons Attribution 3.0 Unported License.
 * https://getbootstrap.com/docs/5.3/customize/color-modes/#javascript
 */

(() => {
  "use strict";

  // The color scheme choice is stored in user settings and initially embedded
  // in the `data-bs-theme` attribute on the `html` element. When "match system"
  // is selected, the attribute's value is auto. The theme switcher component
  // updates the data-user-theme attribute when the user setting changes.
  document.documentElement.setAttribute(
    "data-user-theme",
    document.documentElement.getAttribute("data-bs-theme"),
  );

  const getUserColorScheme = () => {
    return document.documentElement.getAttribute("data-user-theme") || "auto";
  };

  const getPreferredTheme = () => {
    const colorScheme = getUserColorScheme();

    if (colorScheme && colorScheme !== "auto") {
      return colorScheme;
    }

    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  };

  const setTheme = (theme) => {
    document.documentElement.setAttribute("data-bs-theme", theme);
  };

  // Set the theme on page load, before rendering content
  setTheme(getPreferredTheme());

  // Watch for changes to system theme
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", () => {
      setTheme(getPreferredTheme());
    });

  // Watch for changes to data-user-theme
  const observer = new MutationObserver(() => {
    setTheme(getPreferredTheme());
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-user-theme"],
  });
})();
